import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

// COMPONENTS

// CONFIG

// INTERFACES
import {
  IAgGridSideMenuItem,
  IAgGridSideMenuItemConfig,
} from '../../interfaces/ag-grid';
import { IAgGridFilter } from '../../interfaces/ag-grid-filter.interface';

// SERVICES

// UTILS
import { trackById, trackByLabel } from '../../util/track-by.util';

export interface ISidemenuItemTemplateParams {
  badgeColorClass ?:string;
  badgeLabel ?:string;
  colorClass ?:string;
  label :string;
}
export const sidemenuItemTemplate = (
  params :ISidemenuItemTemplateParams,
) :string => {
  const badgeTemplate =
    params.badgeLabel == null
      ? ''
      : `<div class="item-badge ${params.badgeColorClass}">
          ${params.badgeLabel}
        </div>`;

  return `
      <div class="d-flex align-items-center justify-space-between">
        <div class="flex align-items-center">
          <i class="fas fa-circle ${params.colorClass} mr-3"></i>
          ${params.label}
        </div>
        ${badgeTemplate}
      </div>
    `;
};

@Component({
  selector: 'lum-ag-grid-sidemenu',
  templateUrl: './ag-grid-sidemenu.component.html',
  styleUrls: ['./ag-grid-sidemenu.component.scss'],
})
export class AgGridSidemenuComponent implements OnInit {
  @Input()
  enablePrimaryMenu :boolean = true;

  @Input()
  menuItems :IAgGridSideMenuItem[] = [];

  @Input()
  config :IAgGridSideMenuItemConfig = {};

  @Input()
  activeMenu :string | null = '';

  @Input()
  enableCustomFilters :boolean = false;

  @Input()
  customFilters :IAgGridFilter[] = [];

  @Input()
  loadingCustomFilters :boolean = false;

  @Output()
  setActiveMenuItemEvent :EventEmitter<string> = new EventEmitter<string>();

  @Output()
  setFilterEvent :EventEmitter<{ action :string; filter :IAgGridFilter }> =
    new EventEmitter<{ action :string; filter :IAgGridFilter }>();

  @Output()
  saveFilterEvent :EventEmitter<boolean> = new EventEmitter<boolean>();

  trackByLabel = trackByLabel;
  trackById = trackById;
  disabledItemStyle = {
    color: '#cdcdcf',
    'background-color': 'transparent',
    cursor: 'not-allowed',
  };

  constructor(private cd :ChangeDetectorRef) {}

  ngOnInit() :void {
    this.cd.detectChanges();
  }

  onSetMenuActive(menu :string) :void {
    this.setActiveMenuItemEvent.emit(menu);
  }

  onSetFilter(action :string, filter :IAgGridFilter) :void {
    this.setFilterEvent.emit({
      action,
      filter,
    });
  }

  onSaveFilter() :void {
    this.saveFilterEvent.emit(true);
  }
}
